// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Eu-z","srOnly":"Fu-z"};